module.exports = __webpack_public_path__ + "media/reskin-images/icon--h2h-alert-697b522d.svg";